import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faSpinner,
  faChevronDown
} from '@fortawesome/free-solid-svg-icons'

library.add(
  faSpinner,
  faChevronDown
)
